import React from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';

const data = [
  { mois: 'Jan', utilisateurs: 40 },
  { mois: 'Fév', utilisateurs: 65 },
  { mois: 'Mar', utilisateurs: 50 },
  { mois: 'Avr', utilisateurs: 80 },
  { mois: 'Mai', utilisateurs: 72 },
  { mois: 'Jun', utilisateurs: 95 },
];

const statsCards = [
  { label: 'Utilisateurs', value: '1,234', icon: '👥', color: 'bg-blue-600' },
  { label: 'Revenus', value: '4,500 FCFA', icon: '💰', color: 'bg-green-600' },
  { label: 'Commandes', value: '320', icon: '📦', color: 'bg-purple-600' },
  { label: 'Messages', value: '58', icon: '✉️', color: 'bg-yellow-600' },
];

const Dashboard = () => {
  return (
    <div className="flex min-h-screen bg-gray-900">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-6">

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {statsCards.map((card, index) => (
              <div key={index} className="bg-gray-800 rounded-xl p-4 flex items-center gap-4">
                <div className={`${card.color} w-12 h-12 rounded-lg flex items-center justify-center text-2xl`}>
                  {card.icon}
                </div>
                <div>
                  <p className="text-gray-400 text-sm">{card.label}</p>
                  <p className="text-white text-xl font-bold">{card.value}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Chart */}
          <div className="bg-gray-800 rounded-xl p-6">
            <h3 className="text-white font-semibold mb-4">Croissance des utilisateurs</h3>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
                <XAxis dataKey="mois" stroke="#9CA3AF" />
                <YAxis stroke="#9CA3AF" />
                <Tooltip
                  contentStyle={{ backgroundColor: '#1F2937', border: 'none', borderRadius: '8px' }}
                  labelStyle={{ color: '#F9FAFB' }}
                />
                <Bar dataKey="utilisateurs" fill="#3B82F6" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Dashboard;